import {
  SELECT_RECIPE,
  SET_RECIPE_QUANTITY,
  UNSELECT_RECIPE,
  TOGGLE_NEED_INGREDIENT,
  ADD_EXTRA_INGREDIENT,
  REMOVE_EXTRA_INGREDIENT,
  ADD_LIST,
  EDIT_LIST,
  CLEAR_SHOPPING,
} from "../../constants/reducerEvents";

const INITIAL_STATE = {
  name: "Grocery List",
  selected: [],
  extraIngredients: [],
  checked: [],
  id: null,
  date: null,
  finished: false,
};
export default function shoppingReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_SHOPPING:
      return INITIAL_STATE;
    case EDIT_LIST:
      return action.payload;
    case ADD_LIST:
      return INITIAL_STATE;
    case SELECT_RECIPE:
      return {
        ...state,
        selected: [
          ...state.selected,
          {
            recipe: action.payload,
            quantity: parseInt(action.payload.recipeYield),
            ingredients: action.payload.recipeIngredients.map((i) => false),
          },
        ],
      };
    case UNSELECT_RECIPE:
      return {
        ...state,
        selected: state.selected.filter(
          (r) => r.recipe.url != action.payload.url
        ),
      };
    case SET_RECIPE_QUANTITY:
      return {
        ...state,
        selected: state.selected.map((r) => {
          if (r.recipe.url !== action.payload.url) {
            return r;
          }
          return {
            ...r,
            quantity: action.payload.quantity,
          };
        }),
      };
    case TOGGLE_NEED_INGREDIENT: //{url,index}
      return {
        ...state,
        selected: state.selected.map((r) => {
          if (r.recipe.url !== action.payload.url) {
            return r;
          }
          return {
            ...r,
            ingredients: r.ingredients.map((ing, i) => {
              if (i === action.payload.index) {
                return !ing;
              }
              return ing;
            }),
          };
        }),
      };
    case ADD_EXTRA_INGREDIENT:
      return {
        ...state,
        extraIngredients: [...state.extraIngredients, action.payload],
      };
    case REMOVE_EXTRA_INGREDIENT:
      return {
        ...state,
        extraIngredients: state.extraIngredients.filter(
          (_, index) => index != action.payload
        ),
      };
    default:
      return state;
  }
}
